import React from 'react'
import { Helmet } from 'react-helmet'
import { MDXProvider } from '@mdx-js/react'
import SiteMetadata from '../components/SiteMetadata'
import Footer from '../components/Footer'
import Navbar from '../components/Navbar'
import CartWidget from '../components/CartWidget'
import '../styles/_all.sass'

// Set up MDX Shortcodes
import Anchor from './shortcodes/Anchor'
import Button from './shortcodes/Button'
import ContactForm from './shortcodes/ContactForm'
import Cta from './shortcodes/Cta'
import FaqSection from './shortcodes/FaqSection'
import FauxTitle from './shortcodes/FauxTitle'
import FeaturedCategories from './shortcodes/FeaturedCategories'
import Phone from './shortcodes/Phone'
import Plural from './shortcodes/Plural'
import Products from './shortcodes/Products'

const shortcodes = {
  Anchor,
  Button,
  ContactForm,
  Cta,
  FaqSection,
  FauxTitle,
  FeaturedCategories,
  Phone,
  Plural,
  Products,
}

/**
 * Construct the global layout
 *
 * @param {string} [className]
 */
const TemplateWrapper = props => {
  const { title, globalSchema } = SiteMetadata()

  return (
    <div>
      <Helmet>
        <html lang="en-gb" />
        <title>{props.seoTitle || props.title + ' | ' + title}</title>
        <meta name="description" content={props.seoDescription} />
        <script type="application/ld+json">{globalSchema}</script>
        <script type="application/ld+json">{props.seoSchema}</script>
      </Helmet>
      <Navbar solid={props.heroImage ? false : true} />
      <div id="main" className={props.className}>
        <MDXProvider components={shortcodes}>{props.children}</MDXProvider>
        <CartWidget />
      </div>
      <Footer showContactForm={props.showContactForm} />
    </div>
  )
}

export default TemplateWrapper
